import { PaymentPageLazy as PaymentPageLazyV0 } from './deprecated';
import { PaymentPageLazy as PaymentPageLazyV1 } from './PaymentPage.lazy';


const PaymentPages = [
    PaymentPageLazyV1,
    PaymentPageLazyV0,
];

const [ PaymentPage ] = PaymentPages;

export const PaymentPageProcess = () => {
    return (
        <PaymentPage />
    );
};
